import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetUniversitiesQuery } from "../../hooks/useGetUniversitiesQuery";
import { setPreviousPath } from "../../redux/slices/previousPath";
import { setUniversityData } from "../../redux/slices/school/university";
import { routes } from "../../routes";
import { updateUniversity } from "../../services/school/university/university";
import { UniversityType } from "../../types/University";
import { Key_universities } from "../../utils/constants";

const columnNamesMap: { [key: string]: string } = {
    description: "Nome",
};

export default function Universities() {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemToBeDeleted, setItemToBeDeleted] = useState<UniversityType | null>(null);

    const queryClient = useQueryClient();
    const dispatch = useAppDispatch();
    const { data, status } = useGetUniversitiesQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdate = useMutation(updateUniversity, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_universities);
            toast.success("Instituição de Ensino Superior removida");
        },
        onError: () => {
            toast.error("Erro ao apagar instituição de ensino superior.");
        }
    });

    const handleCreate = () => {
        navigate(routes.createUniversity);
    };

    const handleEdit = (university: UniversityType) => {
        dispatch(setUniversityData(university));
        navigate(routes.updateUniversity);
    };
    const handleAssignManagers = (faculty: UniversityType) => {
        dispatch(setUniversityData(faculty));
        dispatch(setPreviousPath(routes.universities))
        navigate(routes.assignManager)

    };
    const handleDelete = (university: UniversityType) => {
        university.status = false;
        mutationUpdate.mutateAsync(university);
    };
    const openDeleteDialog = (s: UniversityType) => {
        setItemToBeDeleted(s);
    };
    const confirmDelete = () => {
        if (itemToBeDeleted) {
            handleDelete(itemToBeDeleted)
        }
    };
    const options = data?.items.map((university) => [
        {
            label: "Editar",
            onClick: () => handleEdit(university),
            icon: <Pencil1Icon />
        },
        {
            label: 'Vincular responsável',
            onClick: () => handleAssignManagers(university),
            icon: <Pencil1Icon />
        },
        {
            label: "Excluir",
            onClick: () => openDeleteDialog(university),
            icon: <TrashIcon />
        },
    ]) || [];
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    return (
        <>
            <Lists
                status={status}
                TableComponent={() => (
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                    />
                )}
                handleClickCreate={handleCreate}
            />
            <ConfirmAlertDialog
                open={!!itemToBeDeleted}
                onOpenChange={(open) => !open && setItemToBeDeleted(null)}
                title="Esta operação é irreversível"
                item={itemToBeDeleted}
                onConfirm={confirmDelete}
                onCancel={() => setItemToBeDeleted(null)}
            />
        </>
    );
}